import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { ComponentsModule } from '../../components/components.module';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { CatalogoLudicoComponent } from './catalogoludico.component';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { DetalleLudicoModule } from './detalle/detalleludico.module';


@NgModule({
    declarations:[
        CatalogoLudicoComponent
    ],
    imports:[
        ComponentsModule,
        DetalleLudicoModule,
        AngularFontAwesomeModule,
        BrowserModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports:[
        CatalogoLudicoComponent
    ]
})
export class CatalogoLudicoModule {}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }